<template>
    <Modal class="prompt-modal"
           :icon="icon"
           :title="title"
           :custom-title-text="customTitleText"
           :size="modalSize">
        <DialogText :text-lang-keys="textLangKeys"
                    :custom-text="customText"
                    :custom-html="customHtml " />

        <form class="form-v"
              @submit.prevent="ok">
            <div class="form-group">
                <label v-if="inputLabel"
                       for="prompt-value"
                       class="block text-center">
                    {{ l(inputLabel, inputLabelParams) }}
                </label>
                <input id="prompt-value"
                       v-model="form.value"
                       v-auto-focus
                       type="text"
                       :maxlength="maxLength ? maxLength : ''"
                       class="form-control input-lg text-center"
                       @keyup="onKeyUp()"
                       @keydown.enter="ok" />
            </div>

            <DialogCustomInputs v-if="customInputs"
                                :custom-inputs="customInputs"
                                :form="form"
                                @enter="ok" />
        </form>

        <template v-slot:footer>
            <div class="modl-footer confirm-modal__btns">
                <DialogCancelBtn :color="cancelColor"
                                 :custom-text="cancelCustomText"
                                 :label="cancelLabel"
                                 @click="cancel" />

                <SquareBtn v-for="btn in customBtns"
                           :key="`btn-${btn.label}`"
                           :color="btn.color"
                           :disabled="!!btn.disabled"
                           size="lg"
                           block
                           @click="customBtnClick(btn)">
                    {{ l(btn.label) }}
                </SquareBtn>

                <DialogOkBtn :color="okColor"
                             :custom-text="okCustomText"
                             :label="okLabel"
                             @click="ok" />
            </div>
        </template>
    </Modal>
</template>

<script>
import DialogCancelBtn from '@/vue/modals/Dialogs/components/DialogCancelBtn';
import DialogCustomInputs from '@/vue/modals/Dialogs/components/DialogCustomInputs';
import DialogOkBtn from '@/vue/modals/Dialogs/components/DialogOkBtn';
import DialogText from '@/vue/modals/Dialogs/components/DialogText';
import Modal from '@/vue/components/Modals/Modal';
import SquareBtn from '@/vue/components/SquareBtn';
import { autoFocus } from '@/vue/directives/autoFocus';
import { container } from '@/container';
import { DialogPropsMixin } from '@/vue/modals/Dialogs/mixins/DialogPropsMixin';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    components: {
        DialogCancelBtn,
        DialogCustomInputs,
        DialogOkBtn,
        DialogText,
        Modal,
        SquareBtn,
    },

    directives: {
        autoFocus,
    },

    mixins: [
        DialogPropsMixin,
        ModalPropsMixin,
    ],

    props: {
        defaultValue: {
            type: String,
            default: '',
        },
        inputLabel: {
            type: String,
            default: null,
        },
        inputLabelParams: {
            type: Object,
            default: () => {
            },
        },
        maxLength: {
            type: Number,
            default: null,
        },
        minLength: {
            type: Number,
            default: null,
        },
        regex: {
            type: Object,
            default: null,
        },
        customBtns: {
            type: Array,
            default: () => [],
        },
        keyUp: {
            type: Function,
            default: null,
        },

        // Custom inputs - see the DialogCustomInputs component.
        customInputs: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            form: {
                value: this.defaultValue,
            },
        };
    },

    methods: {
        onKeyUp() {
            if (this.keyUp) {
                this.form.value = this.keyUp(this.form.value);
            }
        },

        ok() {
            if (this.minLength && this.form.value.length < this.minLength) {
                container.toastFactory.warningTop(
                    null,
                    container.langService.getText('DIALOGS.PROMPT_TOO_SHORT', { min: this.minLength }),
                );
                return;
            }

            if (this.maxLength && this.form.value.length > this.maxLength) {
                container.toastFactory.warningTop(
                    null,
                    container.langService.getText('DIALOGS.PROMPT_TOO_LONG', { max: this.maxLength }),
                );
                return;
            }

            if (this.regex && !this.regex.test(this.form.value)) {
                container.toastFactory.warningTop(
                    null,
                    container.langService.getText('DIALOGS.PROMPT_INVALID_FORMAT'),
                );
                return;
            }

            this.resolve(this.form);
        },

        customBtnClick(btn) {
            btn.handler(this);
        },
    },
};
</script>
